
import request from '@/utils/http';

/**
 *
 * @param {*} params {"platformCode":"WB202206280017","applicationCode":"APP202009170012","sortNo":2}
 * @returns
 */
export const getUserPlatformApps = (params) => {
    return request({
        url: '/api-auth/userPlatformApps',
        method: 'post',
        data: params
    }).then(res => res);
};

export const deleteUserPlatformApps = (params) => {
    return request({
        url: '/api-auth/userPlatformApps/' + params.id,
        method: 'delete'
    }).then(res => res);
};

/** 获取列表
 * {\"platformCode\":\"WB202206280017\",\"userCode\":\"\"}
 */
export const getUserPlatformAppsList = (params) => {
    return request({
        url: '/api-auth/userPlatformAppsList',
        method: 'post',
        data: params
    }).then(res => res);
};
